import { cloneDeep, get, set } from 'lodash';
import { Vif } from 'common/visualizations/vif';
import { TableColumnFormats } from 'common/visualizations/views/agGridReact/types';

function setIsFormatSubtotalFromTotals(columnFormats: TableColumnFormats): TableColumnFormats {
  return Object.entries(columnFormats).reduce<TableColumnFormats>((updatedFormats, [columnName, format]) => {
    updatedFormats[columnName] = format.isFormatTotal ? { ...format, isFormatSubtotal: true } : format;
    return updatedFormats;
  }, {});
}

// Migrate from VIF version 9 to 10 by setting isFormatSubtotal to true if isFormatTotal is true
// for each column in columnFormats.
export function migrateVif9ToVif10(vifToMigrate: Vif): Vif {
  const migratedVif = cloneDeep(vifToMigrate);

  if (get(vifToMigrate, 'series[0].type') === 'agTable') {
    const columnFormat: TableColumnFormats = get(migratedVif, 'series[0].formatting.columnFormat');
    if (columnFormat) {
      set(migratedVif, 'series[0].formatting.columnFormat', setIsFormatSubtotalFromTotals(columnFormat));
    }
  }

  migratedVif.format.version = 10;
  return migratedVif;
}
